<template>
    <div id="exam">
     <div class="header">
        <div class="header-log">
            <img src = "static/image/hengan_logo@3x.png" style="height: 30px;"/>
        </div>
        <!-- <span class="title">{{generateExamPaperReqvo.paperType == '0'?'新人入司考试':generateExamPaperReqvo.paperType=='NEW_RISK'?'新人险种试卷':'地区入司考试'}}</span> -->
        <span class="title">{{ titleFix(generateExamPaperReqvo.paperType) }}</span>
        <el-button type="primary"  class="header-submit-btn" @click="showWarnDialog ()">交卷</el-button>
        <div class="left-time">
           剩余时间： {{timeCountDown}}
        </div>
        <div class="left-time">
          {{psnName}}({{pId}})
        </div>

    </div>
    <!-- 题目 -->
    <div class="container" :style="fullHeight">
      <div class="question"   v-for="(question,index) in questionList" :key="index" >
        <div class="subject-div" :id="'question_'+index"> {{(index+1)+". （" + (question.single?'单选题':'多选题') + "）"+question.subject}}</div>
        <div class="option-div" v-if="!question.single">
          <el-checkbox-group  fill="#C3A770" v-model="answerList[index]" v-for="(optionInfo,key) in question.optionInfoList" :key="key">
            <el-checkbox :name="optionInfo.optionName" :label="optionInfo.optionName">{{optionInfo.optionName+"."+optionInfo.optionDetail}}</el-checkbox>
          </el-checkbox-group>
        </div>

        <div class="option-div" v-if="question.single">
          <el-radio-group v-model="answerList[index][0]">
            <el-radio :label="optionInfo.optionName" v-for="(optionInfo,key) in question.optionInfoList" :key="key">{{optionInfo.optionName+"."+optionInfo.optionDetail}}</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <!-- 题目一览表 -->
    <el-popover
      placement="top"
      width="400"
      trigger="click"
      popper-class="exam_popover"
      >
          <div class="question-summary">已答题<span>{{answerCount+"/"+questionList.length}}</span></div>
           <div  v-for="(question,index) in questionList" :key="index" class="question-div" >
             <div @click="goToQuestion(index)" :class="{'question-round':true,'answered':null != answerList&&null != answerList[index] && answerList[index].length>0}">{{index+1}}</div>
           </div>
      <el-button  type="primary" slot="reference" class="summary-btn" @click="summary_show()">
        <div style="width:50px;margin: auto;">
        <div style="float:left"><img src="../../assets/exam/exam_summary.png"></div>
        <div style="float:left;    margin-top: 2px;">考卷 </div>
        <div style="clear:both"></div>
        </div></el-button>
    </el-popover>
    <!-- 提交判断 -->
    <el-dialog
      title="提示"
      :visible.sync="submitShow"
      :show-close="false"
      width="50%"
      center>
      <div class="submit-content">
          <div >1.点击【交卷】按钮，将提交试卷，结束考试。</div>
          <div>2.点击【答卷】按钮，将返回页面，继续考试。</div>
          <div>3.您当前完成<span class="red">{{answerState.finished}}</span>道考题，剩余<span class="red">{{answerState.unfinished}}</span>道考题未做。</div>
          <div style="word-break: break-word;">4.未完成题号为：<span class="red" v-if="unfinishedLeftStr == ''||unfinishedAllShow"><br/>{{unfinishedStr}}</span>
          <span class="red" v-else>{{unfinishedLeftStr }}<span @click="unfinishedAllShow=true">....</span>{{unfinishedRightStr}} </span></div>
      </div>
      <span slot="title" class="submit-dialog-title">
        <div class="submit-title">考试交卷提示 </div>
      </span>
      <span slot="footer" class="submit-dialog-footer">
        <el-button class="submit-btn "  @click="showWarnDialogCancel()">答卷</el-button>
        <el-button type="primary" class="submit-btn" @click="handInPaper()">交卷</el-button>
      </span>
    </el-dialog>
    <!-- 倒计时 -->
    <el-dialog
      title="提示"
      :visible.sync="timeRemainFlag"
      :show-close="false"
      width="35%"
      class="countdownDia"
      center>
      <div class="submit-content">
        <div v-if="fiveMinShow">
              <div class="countDownTxt" >
                考试时间已到，紧张倒计时中!!!
                <span class="countDownTime">{{timeRemainShow}}</span>
              </div>
        </div>
        <div v-if="tenSecondShow" class="countDownTxt">
          离考试结束时间还有5分钟，抓紧时间啊!!!
        </div>
      </div>
      <span slot="title" class="submit-dialog-title">
        <div class="submit-title">考试结束提醒</div>
      </span>
      <span slot="footer" class="submit-dialog-footer" >
        <el-button type="primary" class="submit-btn warnBtn"  @click="timeRemainCancel ()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/modules/api.js'
import session from '@/components/cache'
import url from '@/modules/url'
export default {
  data () {
    return {
      // 剩余时间
      countDown: '',
      timeCountDown: '00:00:00',
      // 剩余时间（毫秒数）
      timeRemain: '',
      fullHeight: {height: ''},
      // 试题列表
      questionList: [],
      // 答案列表
      answerList: [[]],
      // 改动次数
      modifyCount: 0,
      // 试卷生成请求Vo
      generateExamPaperReqvo: {
        // todo ...
        businessNo: '',
        paperType: '0',
        manageCom: ''
      },
      paperCode: '',
      // todo
      businessNo: '',
      examType:'',
      // 答题内容保存请求Vo
      savePaperAnswerReqVo: {
        answerArray: '',
        // todo...
        businessNo: '',
        paperCode: '',
        manageCom: '',
        paperType: ''
      },
      // 试卷信息
      examPaperInfo: {
        questionList: [],
        paperCode: '',
        examEndTime: ''
      },
      // 当前时间
      currentTime: new Date(),
      // 答题情况汇总
      answerState: {
        finished: '',
        unfinished: '',
        unfinishedQues: []
      },
      // 是否显示5分钟的弹框
      fiveMinShow: false,
      // 是否显示10s的弹框
      tenSecondShow: false,
      clickTime: 0,
      submitShow: false,
      answerCount: 0,
      unfinishedAllShow: false,
      unfinishedStr: '',
      unfinishedLeftStr: '',
      unfinishedRightStr: '',
      timeRemainFlag: false,
      timeRemainShow: 0,
      pId:'',
      psnName:''
    }
  },
  mounted () {
    // 获取参数
    this.generateExamPaperReqvo.manageCom = session.session_get('manageCom')
    this.generateExamPaperReqvo.paperType = this.$route.query.type
    this.examType = this.$route.query.type
    this.generateExamPaperReqvo.businessNo = session.session_get('businessNo')
    this.businessNo = session.session_get('businessNo')
    // this.businessNo = this.$route.query.businessNo
    this.savePaperAnswerReqVo.manageCom = this.generateExamPaperReqvo.manageCom
    this.savePaperAnswerReqVo.paperType = this.generateExamPaperReqvo.paperType
    this.savePaperAnswerReqVo.businessNo = this.businessNo
    this.init()
    let that = this
    // 1.请求后台生成试题
    // console.log(that.generateExamPaperReqvo,'1111')
    api.getQuestionList(that.generateExamPaperReqvo, function (res) {
      if (res.result.isSuccess === true) {
        // 2.判断缓存是否有试题信息
        // 判断app 本地缓存有没有数据  todo
        that.generateExamPaperReqvo.paperType = res.data.paperType
        that.examType = res.data.paperType
        that.questionList = res.data.questionList
        that.paperCode = res.data.paperCode
        that.examPaperInfo.examEndTime = res.data.examEndTime
        if (res.data.answerSplitList != null) {
          that.answerList = res.data.answerSplitList
          for (var i = 0; i < that.answerList.length; i++) {
            if (that.answerList[i] == '') {
              that.answerList[i] = []
            }
          }
        } else {
          that.answerList = []
        }
        // 2.1初始化答案数组
        while (that.answerList.length < res.data.questionList.length) {
          that.answerList.push([])
        }
        // 3.计时器
        that.countdown()
      } else {
        that.$message.error(res.result.error)
      }
    })
    that.height()
    window.onresize = () => {
      //                返回值
      return (() => {
        // window.fullHeight = document.documentElement.clientHeight
        // that.fullHeight.height = window.fullHeight - 200
        that.height()
      })()
    }
  },
  methods: {
    titleFix(type){
      if(type == 0){
        return '新人入司考试'
      } else if(type == 'NEW_RISK'){
        return '新人险种考试'
      }else if(type == 'INTERNET'){
        return '互联网宣传和销售资质考试'
      }else{
        return '地区入司考试'
      }
    },
    init(){
      let that =this
      api.post(url.getPuserInfo, {}, function (res) {
        console.log(123,res)
        that.psnName = res.data.psnName
        that.pId = res.data.pId
      })
    },
    singleChange (index) {
      if (this.answerList[index].length > 1) {
        this.answerList[index] = [this.answerList[index][1]]
      }
    },
    height () {
      this.fullHeight.height = window.innerHeight - 200 + 'px'
    },
    summary_show () {
      this.answerCount = 0
      for (var i = 0; i < this.answerList.length; i++) {
        if (this.answerList[i] != null && this.answerList[i].length > 0) {
          this.answerCount++
        }
      }
    },

    // 跳转到题目
    goToQuestion (index) {
      var anchor = this.$el.querySelector('#question_' + index)
      this.$el.querySelector('.container').scrollTop = anchor.offsetTop - 150
    },
    // 计时
    countdown () {
      // 测试
      // let end = new Date(1551963281000)
      let end = this.examPaperInfo.examEndTime
      let current = (new Date()).getTime()

      this.timeRemain = (end - current)
      console.log(this.timeRemain / 1000)
      if (this.timeRemain <= 0) {
        this.timeCountDown = '00:00:00'
      } else {
        let hour = Math.floor(this.timeRemain / 1000 / 60 / 60 % 24)
        let min = Math.floor(this.timeRemain / 1000 / 60 % 60)
        let sec = Math.floor(this.timeRemain / 1000 % 60)
        // if (hour === 0) {
        //   min = Math.floor(this.timeRemain / (60 * 1000))
        //   sec = Math.floor((this.timeRemain / 1000) - (min * 60))
        // } else {
        //   min = Math.floor(this.timeRemain / (60 * 1000) - (hour * 60))
        //   sec = Math.floor((this.timeRemain % (60 * 1000) / 60))
        // }

        this.timeCountDown = (hour < 10 ? '0' + hour : hour) + ':' + (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec)

        let that = this
        // 每秒计时
        setTimeout(function () {
          that.countdown()
        }, 1000)
      }
    },

    // 交卷
    handInPaper () {
      var that = this
      that.savePaperAnswerReqVo.answerArray = that.answerList
      that.savePaperAnswerReqVo.paperCode = that.paperCode
      that.savePaperAnswerReqVo.loadingMessage = '正在判卷，请耐心等待'
      api.handInPaper(that.savePaperAnswerReqVo, function (res) {
        if (res.result.isSuccess === true) {
          // 跳转路由
          that.$router.push({name: 'ExamResult', query: {type: that.examType}})
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    // 判断是否显示 考试及即将结束提醒
    showWarnDialog () {
      // 未答题数量
      var unfinished = 0
      // 未答题编号
      var unfinishedArray = []
      for (var k = 0; k < this.answerList.length; k++) {
        if (this.answerList[k].length === 0) {
          unfinished++
          unfinishedArray.push(k + 1)
        }
      }

      this.answerState.unfinished = unfinished
      this.answerState.finished = this.answerList.length - unfinished
      if (unfinishedArray.length > 5) {
        this.unfinishedStr = unfinishedArray.join(',')
        this.unfinishedLeftStr = unfinishedArray.slice(0, 4).join(',')
        this.unfinishedRightStr = unfinishedArray.slice(unfinishedArray.length - 1, unfinishedArray.length).join(',')
        this.submitShow = true
      } else if (unfinishedArray.length === 0) {
        this.handInPaper()
      } else {
        this.unfinishedLeftStr = ''
        this.unfinishedStr = unfinishedArray.join(',')
        this.submitShow = true
      }
      // this.answerState.unfinishedQues = unfinishedArray.join(',')
      // 显示是否交卷弹框
    },
    showWarnDialogCancel () {
      this.unfinishedAllShow = false
      this.submitShow = false
    },
    timeRemainCancel () {
      var timeRemain = parseInt(this.timeRemain / 1000)
      if (this.timeRemainFlag) {
        if (timeRemain < 10) {
          this.clickTime = 2
        } else if (timeRemain < 300) {
          this.clickTime++
        }
      }
    }

  },
  watch: {
    // 保存答案到本地缓存
    answerList: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.modifyCount++

        var that = this

        this.savePaperAnswerReqVo.answerArray = this.answerList
        this.savePaperAnswerReqVo.paperCode = this.paperCode
        // 10次改动
        if (this.modifyCount > 10) {
          // 保存用户的答题
          api.savePaperAnswers(this.savePaperAnswerReqVo, function (res) {
            that.modifyCount = that.modifyCount % 10
          })
        }
      }
    },
    // 时间到时 自动交卷
    timeRemain: {
      handler: function (newVal, oldVal) {
        var timeRemain = parseInt(this.timeRemain / 1000)
        this.timeRemainShow = timeRemain
        // 判断考试是否结束
        if (timeRemain <= 0) {
          this.timeRemainFlag = false
          this.handInPaper()
          return
        }
        var that = this

        if (timeRemain < 10) {
          that.fiveMinShow = true
          that.tenSecondShow = false
        } else if (timeRemain < 300) {
          that.tenSecondShow = true
          that.fiveMinShow = false
        }

        // 判断是否应该弹框
        that.timeRemainFlag = false

        if (timeRemain < 10) {
          if (this.clickTime < 2) {
            that.timeRemainFlag = true
          }
        } else if (timeRemain <= 5 * 60) {
          if (this.clickTime === 0) {
            that.timeRemainFlag = true
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
   #exam .header{
    background-color: #F5F6FA;
    height: 80px;
    padding: 0 1% ;
    text-align: center
  }
   #exam .header-log{
    float: left;
    margin-top: 20px;
  }
   #exam .left-time{
    float: right;
    margin:30px 1% 0 0;
  }
  #exam .header .title{
    text-align: center;
    padding-top: 30px;
    display: inline-block;
    font-size: 20px;
  }
  #exam .header .header-submit-btn{
    float: right;
    margin-top:20px;
    background-color:#C2A66E;
    border-color:#C2A66E;
  }

#exam .container{
    // width: 90%;
    // margin: 50px 5% 0 5%;
    border:solid 1px #E5E5E5;
    min-height: 500px;
    overflow-y: auto;
    padding:0 5%;
    width:90%;
    margin:0 auto;
    margin-top: 50px;
    box-sizing: border-box;
    -webkit-box-sizing:border-box;
}
 #exam .summary-btn{
    background-color: #194793;
    float: right;
    margin: 10px 1% 0 0;
    width: 15%;
    max-width: 250px;
}
 #exam .summary-btn img{
  height: 18px;
  margin-right: 2px;
}
 #exam /deep/  .el-checkbox, .el-checkbox__input{
      white-space: initial;
      padding-bottom: 5px
}
 #exam /deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
      background-color: #C3A770;
    border-color: #C3A770;
}
 #exam /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #C3A770
}
 #exam /deep/ .el-checkbox__label{
  color: #111111;
  display: inline;
}
#exam .el-radio-group, .el-radio__input{
    white-space: initial;
    padding-bottom: 5px;
}
 #exam /deep/ .el-radio__input.is-checked .el-radio__inner{
    background-color: #C3A770;
    border-color: #C3A770;
}
#exam /deep/ .el-radio__input.is-checked+.el-radio__label{
  color: #C3A770
}
 #exam /deep/.el-radio__label{
  color: #111111;
  display: inline;
}

#exam .subject-div{
  margin-bottom: 10px;
  line-height:24px;
}
#exam .option{
  margin-bottom: 5px
}
 #exam .question{
    padding: 20px 0;
    border-bottom: solid 1px #E5E5E5;
}
.exam_popover .question-div{
  height:30px;
  width: 10%;
  display: inline-block;
}
.exam_popover .question-round{

   height: 23px;
   width: 23px;
   text-align: center;
   border-radius: 50%;
   text-align: center;
   line-height: 23px;
   color: #000;
   font-size: 12px;
   margin: 0 auto;
   border: solid 1px #9E9FA0;
   cursor: pointer;
}
.exam_popover .answered{
  border: solid 0.01rem #5ffab3;
  background-color: #5ffab3;
}
.exam_popover .question-summary{
    height: 50px;
    line-height: 50px;
    text-align: right;
}
.exam_popover .question-summary span{
    color: #194793;
    font-weight: 900
}
#exam .van-checkbox__icon--checked  .van-icon{
    border-color: #C2A66E;
    background-color: #C2A66E
}
#exam .van-checkbox__icon--checked+.van-checkbox__label{
  color:#C2A66E
}
#exam .submit-btn{
  width: 30%;
  text-align: center;
}
#exam .submit-pop-div{
  width: 80%;
  border-radius: 5%;

}
#exam .submit-title{
    text-align: center;
    // margin: 0.4rem 0 0.3rem 0;
    font-weight: 900;
    margin-top: 10px;
}
#exam .submit-content{
    padding: 5%;
    // border-bottom: solid 0.01rem #DFDFDF;
    line-height: 24px;
}

#exam .red{
  color: #FF6969
}
.warnBtn{
  background:#C2A66E;
  border: none;
}
.countdownDia /deep/ .el-dialog__footer{
  padding: 10px 20px 40px;
}
.countDownTxt{
  color: #252525;
  text-align: center;
}
.countDownTime{
  display: block;
  margin-top: 15px;
  font-weight:900;
  font-size:18px;
}
// .countdownDia /deep/ {

// }
.el-radio{
  margin-left: 0px;
  // margin-right: 30px;
  line-height:24px;
  display: block;
  white-space: inherit;
}

</style>



// WEBPACK FOOTER //
// src/pages/exam/exam.vue